"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var bridgestone_svg_1 = __importDefault(require("res/img/bridgestone.svg"));
var query_svg_1 = __importDefault(require("res/img/query.svg"));
var tyre_manager_svg_1 = __importDefault(require("res/img/tyre-manager.svg"));
var collapse_svg_1 = __importDefault(require("res/img/collapse.svg"));
var navState_1 = require("../../contexts/navState");
var Nav = function (_a) {
    var collapsed = _a.collapsed, onCollapseToggle = _a.onCollapseToggle;
    return (react_1.default.createElement("div", { className: "nav flex flex-column", "data-collapsed": collapsed === navState_1.NavState.COLLAPSED },
        react_1.default.createElement("div", { className: "nav__logo-space flex flex-column" },
            react_1.default.createElement("img", { src: bridgestone_svg_1.default, alt: "Bridgestone" })),
        react_1.default.createElement("div", { className: "nav__menu flex flex-column" },
            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/", title: "Query Log", className: "nav__menu__item flex flex-row" },
                react_1.default.createElement("img", { src: query_svg_1.default, alt: "Query Log" }),
                react_1.default.createElement("span", null, "Query Log")),
            react_1.default.createElement("a", { href: "https://www.totaltyremanager.eu", title: "Total Tyre Manager", className: "nav__menu__item flex flex-row" },
                react_1.default.createElement("img", { src: tyre_manager_svg_1.default, alt: "Total Tyre Manager" }),
                react_1.default.createElement("span", null, "Total Tyre Manager"))),
        react_1.default.createElement("div", { className: "nav__collapse-toggle flex flex-column flex-center", onClick: onCollapseToggle },
            react_1.default.createElement("div", { className: "nav__collapse-toggle__icon" },
                react_1.default.createElement("img", { src: collapse_svg_1.default, alt: "Collapse" })))));
};
exports.default = Nav;
